export default {
  selectItem(context, item) {
    context.commit("setSelectedItem", item);
  },
};
